<template>
  <div class="text-center">
    <b-form @submit="onSubmit">
      <b-button type="submit" variant="primary">{{ $t('wifi.connect') }}</b-button>
    </b-form>
  </div>
</template>

<script>

export default {
  name: 'SetupWifiCredentialsOpen',
  data() {
    return {
      form: {
        encryption: 'open',
      },
    }
  },
  methods: {
    onSubmit() {
      this.$emit('connect', this.form);
    }
  }
}
</script>
